export const defaultMenu = [{ label: 'Home', icon: 'home', routerLink: ['/app'] }];
